<app-header [isCollapsed]="isSidebarCollapsed"></app-header>

<div class="main-container" [class.sidebar-collapsed]="isSidebarCollapsed">
  <app-sidebar (collapsedChange)="onSidebarToggle($event)"></app-sidebar>
  <div class="content" [style.overflow-y]="role === enumRole.SUPER_ADMIN ? 'scroll' : 'auto'">
    <router-outlet></router-outlet>
  </div>
</div>
